import React from 'react'
import { Route, Routes } from 'react-router'
import Transactions from '../../Pages/Transactions/index'
import Beneficiaries from '../../Pages/Beneficiaries/index'
import Settings from '../../Pages/Settings/index'
import LoggedInUser from '../../Pages/Dashboard/UserDashboard/LoggedIn'
import Bills from '../Bills/Index'
import Epin from '../Epins'
import BulkRecharge from '../BulkRecharge'
function Routess() {
  return (
    <div>
        <Routes>
        <Route path='/dashboard' element={<LoggedInUser/>}/>
        <Route path="/transactions" element={<Transactions/>} />
        <Route path="/beneficiaries" element={<Beneficiaries/>} />
        <Route path="/settings" element={<Settings/>} />
        <Route path='/bills' element={<Bills/>}/>
        <Route path='/epin' element={<Epin/>}/>
        {/* <Route path='/bulkrecharge' element={<BulkRecharge/>}/> */}
      </Routes>
    </div>
  )
}

export default Routess